import {default as axios, getBaseUrl} from "src/utils/axios";
import { DownloadFile } from "src/utils/file";
import { URLS } from "src/utils/url";
import appMobileService from "./appMobile.service";
import layoutService from 'src/services/layoutService';

class InvoiceService {
	constructor() {
	}

	search(params) {
		return axios
			.get(URLS.INVOICES, { params: params })
			.catch(err => {
				console.error('searchInvoices', err);
			});
	}

	download(id, type) {
		let url = `${URLS.INVOICES}/${id}/download/${type}`;
		// let url = `${URLS.INVOICES}/2125/download/${type}`;
		if (appMobileService.isMobile()) {
			let baseUrl = '';

			let string = getBaseUrl();
			console.log("string", string);
			let lastCharacter = string.substr(string.length - 1);

			if(lastCharacter === "/") baseUrl = string.slice(0,-1);
			else baseUrl = string;
			console.log("baseUrl", baseUrl);
			
			url = `${baseUrl}${url}`;

			appMobileService.downloadDocument(url);
			return new Promise((resolve, reject) => resolve());
		}
		
		return DownloadFile(url , {})
	}

	downloadXlsx(id) {
		let url = `${URLS.INVOICES}/${id}/downloadXlsx/`;
		if (appMobileService.isMobile()) {
			let baseUrl = '';

			let string = getBaseUrl();
			console.log("string", string);
			let lastCharacter = string.substr(string.length - 1);

			if(lastCharacter === "/") baseUrl = string.slice(0,-1);
			else baseUrl = string;
			console.log("baseUrl", baseUrl);
			
			url = `${baseUrl}${url}`;

			appMobileService.downloadDocument(url);
			return new Promise((resolve, reject) => resolve());
		}
		
		return DownloadFile(url , {})
	}

	downloadPdpRecuperaRt(id) {
		let url = `${URLS.INVOICES}/${id}/downloadRt/`;

		
		console.log('appMobileService.isMobile() ', appMobileService.isMobile());
		console.log('layoutService.isMobile() ', layoutService.isMobile());

		if (appMobileService.isMobile()) {
			let baseUrl = '';

			let string = getBaseUrl();
			console.log("string", string);
			let lastCharacter = string.substr(string.length - 1);

			if(lastCharacter === "/") baseUrl = string.slice(0,-1);
			else baseUrl = string;
			console.log("baseUrl", baseUrl);
			
			url = `${baseUrl}${url}`;

			appMobileService.downloadDocument(url);
			return new Promise((resolve, reject) => resolve());
		}

		return DownloadFile(url , {});
	}


	pdpAttivaRpt(id) {
		var callBackUrl = '';
		
		/*
		function handleClick() {
			if(appMobileService.isMobile() || layoutService.isMobile())
				history.push('/mobile/supply/invoices', { entity });
			else 
				history.push(`/app/supply/${contractLineId}/invoices`, { entity });
		}
	    **/

		callBackUrl = `${window.location.origin}/PagoPA`;
		console.log('callBackUrl ', callBackUrl);

		let _params = {
			id: id,
			callBackUrl:callBackUrl
		};

		return axios.get( `${URLS.INVOICES}/pdpAttivaRpt/`, {params: _params});
	}
}

const invoiceService = new InvoiceService();

export default invoiceService;
